<mat-toolbar color="primary">
  <div class="toolbar-left">
    <h2>{{ headerTitle }}</h2>
  </div>
  <div class="toolbar-right">
    <span class="toolbar-user"><i class="fa fa-user"></i> <span class="toolbar-user-name">{{userName}}</span></span>
  </div>
</mat-toolbar>
